module.exports = __webpack_public_path__ + "static/media/bullseye-arrow.63f074a0.svg";